import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 16.6 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.6 32\" id=\"facebook\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M16.6.2v5.1h-3c-2.4 0-2.8 1.1-2.8 2.8v3.6h5.6l-.7 5.7h-5V32H5V17.4H0v-5.7h5V7.5C5 2.6 8 0 12.1 0a37.1 37.1 0 014.4.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol